import React from "react";
import Box from "@mui/material/Box";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import theme from "../../theme";

const SpeedDialMenu = ({
  actions,
  ariaLabel = "SpeedDial menu",
  position = { bottom: 20, right: 10 },
}) => {
  return (
    <Box sx={{ height: 10, transform: "translateZ(0px)", flexGrow: 1 }}>
      <SpeedDial
        ariaLabel={ariaLabel}
        sx={{
          position: "absolute",
          ...position,
        }}
        icon={<SpeedDialIcon />}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={action.onClick}
          />
        ))}
      </SpeedDial>
    </Box>
  );
};

export default SpeedDialMenu;
